export class UnauthorizedSseError extends Error {
  constructor(message = 'SSE stream returned 401') {
    super(message);
    this.name = 'UnauthorizedSseError';
  }
}
